import { render } from "./MailingBlockSocialsEditor.vue?vue&type=template&id=66ac20b8"
import script from "./MailingBlockSocialsEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockSocialsEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__